define([
	"dojo/_base/declare",
	"csi/heading/NumberFormat"
], function(declare,NumberFormat) {

	return declare(NumberFormat, {
		_getFormats: function() {
			// summary: return array of accepted formats
			return [
				"0",
				"0.0",
				"0.00",
				"0.000",
				"0.0000",
				"0%",
				"0.0%",
				"0.00%"
			];
		},

		/** 
		 * @override
		 * return true if react renderer exists for given attribute type and should be used
		 */
		useReactInlineDialog() {
			return false;
		},

	});
});